export default {
  enImageStyle: "enImageHide",
  cnImageStyle: "cnImageShow",
  menu : {
     home:'首页',
     appSign:"IOS/APP超级签名",
     enterpriseSign:"企业签名",
     aboutUs:"关于我们",
  },
  buttons: {
    registerNow: '立即注册',
    loginToPublish: '登录发布超签APP',
    qqOnline: '24小时在线客服QQ',
  },
  steps: {
    stepsClear:'操作步骤简单清晰',
    cooperation: '1、洽谈合作',
    uploadAppPackage: '2、上传APP原生包',
    signSuccessfully: '3、签名成功',
    recharge: '4、充值',
    exclusiveLinks: '5、分发专属链接'
  },
  adnvantages: {
    fourAdvantages: "4大优势告别掉签烦恼",
    firstOnNetwork: "全网首创",
    firstOnNetworkDescription: "搭载上千台Mac Server，支持大容量高并发下载，特有签名机制，全年不掉签、不闪退，提供链接、二维码和接口多种方式，支持自有连接生成。",
    installAndUse: "安装即用",
    installAndUseDescription: "APP超级签名，无需越狱，无需上架App Store，更新免费，无需手动信任，安装即用，仅提供APP原生包，即可签名，开启分发。",
    costEeffective: '高性价比',
    costEeffectiveDescription: '按需购买，未使用设备不过期，同一设备多次下载同款应用，仅只收费一次，帮您节省大量获客、掉签、运维等成本损失。',
    oneToOne: '1对1专属',
    oneToOneDescription: '专人一对一随时解决您提出的任何问题，可支持独立部署私有云平台服务，支持客户自己页面下载安装，进行商用广告。'
  },
  differences: {
    differentFeaturesPC: '不一样的APP签名,不一样的优点',
    differentFeaturesCN1: '不一样的APP签名,',
    differentFeaturesCN2: '不一样的优点',
    differentFeaturesEN: '',
    difference1: '因机制与传统签名不同，告别掉签',
    difference2: '告别掉签风险，只需支付一次获客成本即可',
    difference3: '同一台设备下载安装该应用不限制下载次数',
    difference4: '按设备数量收费，使用时间可达1年',
    difference5: '安装APP，无需信任授权，用户体验度好',
    difference6: '不植入插件，无后门'
  },
  partners: '合作伙伴',
  companyName: '公司名',
  record: '备案号',
  address: '地址',
  phone: '电话',
  industry: '行业',
  industryValue: '软件公司'
}
